<template>
  <div>
    <div class="content-bottom-padded">
    <el-alert
            type="info"
            title="获取小程序 URL Link，适用于短信、邮件、网页、微信内等拉起小程序的业务场景。通过该接口，可以选择生成到期失效和永久有效的小程序链接，有数量限制 接口文档 https://developers.weixin.qq.com/miniprogram/dev/OpenApiDoc/qrcode-link/url-link/generateUrlLink.html"
            show-icon
    ></el-alert>
    </div>
    <div>
      <el-select v-model="check_wxappid"  placeholder="选择小程序"
                 style="width: 50%;">
        <el-option
                v-for="(item, index) in wx_appid_list"
                :key="index"
                :label="item.name"
                :value="item.value">
        </el-option>
      </el-select>
    </div>
    <div>
      <el-form ref="form" :model="form"  label-width="110px">
        <el-form-item label="path">
          <el-input v-model="form.path" placeholder="进入的小程序页面路径"></el-input>
        </el-form-item>
        <el-form-item label="query">
          <el-input v-model="form.query" placeholder="进入小程序时的query，最大1024个字符，只支持数字，大小写英文以及部分特殊字符：!#$&'()*+,/:;=?@-._~%"></el-input>
        </el-form-item>
        <el-form-item label="is_expire">
          <el-input v-model="form.is_expire" placeholder="默认值false。生成的 URL Link 类型，到期失效：true，永久有效：false。注意，永久有效 Link 和有效时间超过180天的到期失效 Link 的总数上限为10万个"></el-input>
        </el-form-item>
        <el-form-item label="expire_type">
          <el-input v-model="form.expire_type" placeholder="默认值0.小程序 URL Link 失效类型，失效时间：0，失效间隔天数：1"></el-input>
        </el-form-item>
        <el-form-item label="expire_time">
          <el-input v-model="form.expire_time" placeholder="到期失效的 URL Link 的失效时间，为 Unix 时间戳。生成的到期失效 URL Link 在该时间前有效。最长有效期为1年。expire_type 为 0 必填"></el-input>
        </el-form-item>
        <el-form-item label="expire_interval">
          <el-input v-model="form.expire_interval" placeholder="到期失效的URL Link的失效间隔天数。生成的到期失效URL Link在该间隔时间到达前有效。最长间隔天数为365天。expire_type 为 1 必填
"></el-input>
        </el-form-item>
        <el-form-item label="env_version">
          <el-input v-model="form.env_version" placeholder="默认值release。要打开的小程序版本。正式版为 release，体验版为trial，开发版为develop，仅在微信外打开时生效"></el-input>
        </el-form-item>

      <el-col :span="3" class="content-right">
        <el-button type="primary" icon="plus" @click="handleGetQRcode">生成链接</el-button>
      </el-col>
    </el-form>
    </div>
    <div>
      <el-input
              placeholder="短链接"
              v-model="resurl"
              :disabled="true">
      </el-input>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import timeChoose from '../../components/timechoose'
    import { getgenerateUrlLink } from '../../api/wxa'

    export default {
        components: {
            timeChoose
        },
        data () {
            return {
                dialog:false,
                formLabelWidth: '120px',
                loading: false,
                check_wxappid:'',
                wx_url: '',
                wx_scen:'',
                resurl:'',
                form: {
                    'path': '',
                    'query': '',
                    'is_expire': '',
                    'expire_type': '',
                    'expire_time': '',
                    'expire_interval': '',
                    'env_version': '',
                    'wxaappid': '',
                },
                wx_appid_list:[
                    {name:'商城小程序e1b0',value:'wx47d38fb07875e1b0'},
                    {name:'多店铺商城小程序',value:'wx97aa332d3dea7ef2'}
                ],
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            handleGetQRcode:function () {

                this.form.wxaappid = this.check_wxappid

                getgenerateUrlLink(this.form).then(response=>{
                    this.resurl = response.data.data.res
                })
            }
        },
        mounted () {

        }
    }
</script>
<style scoped lang="scss">
  .refresh {
    color: #38f;
    cursor: pointer;
  }
  .el-button a { color: #fff; }
  .el-transfer {
    text-align: center;
    padding: 10px 0 20px;
  }
</style>
<style type="text/css" lang="scss">
  .sources-dialog {
    .el-transfer-panel {
      text-align: left;
      width: 270px;
      .el-transfer-panel__body.is-with-footer {
        box-sizing: content-box;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// get_shortlink.vue?45a5d557